import { TOTAL_NUMBER_FORMAT, applyGridStyle, applyRangeFormats, rangeFormatting } from "../../styles/worksheet";
import { safeWorksheetName } from "../../workbook";
import { dateStampSheet } from "../helpers/dynamicSheets";
import { columnNames, rowNames } from "../helpers/rangeNames";
import { generateVMSummaryReport } from "../vmSummary";
import { titleMaker } from "./common";

export const createVMSummaryTemplate = async () => {
  try {
    return Excel.run(async (context) => {
      const workbook = context.workbook;
      const reportTitle = "VM Summary";
      const safeName = await safeWorksheetName(workbook, reportTitle);
      const sheet = workbook.worksheets.add(safeName);
      await context.sync();

      await titleMaker(sheet, reportTitle);
      const rowHeights = [12, 30, 25, 25];
      rowHeights.forEach((height, index) => {
        sheet.getRange(`${index + 5}:${index + 5}`).format.rowHeight = height;
      });

      const columnWidths = [20, 120, 400, 120, 200, 70, 85, 200, 20];
      columnWidths.forEach((width, index) => {
        sheet.getRange(`${String.fromCharCode(65 + index)}:${String.fromCharCode(65 + index)}`).format.columnWidth =
          width;
      });

      sheet.getRange("1:7").format.verticalAlignment = Excel.VerticalAlignment.center;
      await context.sync();

      // Header row for VM Summary (SOV style)
      const headers: rangeFormatting[] = [
        { rangeAddress: "B6", value: "ID", name: `\\${columnNames.id}`, Halignment: "Left", fontSize: 12, bold: true },
        {
          rangeAddress: "C6",
          value: "Title",
          name: `\\${columnNames.title}`,
          Halignment: "Center",
          fontSize: 12,
          bold: true,
        },
        {
          rangeAddress: "D6",
          value: "Type",
          name: `\\${columnNames.type}`,
          Halignment: "Center",
          fontSize: 12,
          bold: true,
        },
        {
          rangeAddress: "E6",
          value: "VM Category",
          name: `\\${columnNames.vmCategory}`,
          Halignment: "Center",
          fontSize: 12,
          bold: true,
        },
        {
          rangeAddress: "F6",
          value: "Status",
          name: `\\${columnNames.status}`,
          Halignment: "Center",
          fontSize: 12,
          bold: true,
        },
        {
          rangeAddress: "G6",
          value: "Total Cost",
          name: `\\${columnNames.totalCost}`,
          Halignment: "Right",
          fontSize: 12,
          bold: true,
        },
        {
          rangeAddress: "H6",
          value: "Notes",
          name: `\\${columnNames.notes}`,
          Halignment: "Center",
          fontSize: 12,
          bold: true,
        },
      ];
      headers.forEach((header) => {
        header.fontSize = 12;
        header.bold = true;
      });
      applyRangeFormats(sheet, headers);

      const dataRows: rangeFormatting[] = [
        { rangeAddress: "B7", name: rowNames.vmSummary },
        { rangeAddress: "C7", Halignment: "Left" },
        { rangeAddress: "D7", Halignment: "Left" },
        { rangeAddress: "E7", Halignment: "Left" },
        { rangeAddress: "F7", Halignment: "Left" },
        { rangeAddress: "G7", numberFormat: TOTAL_NUMBER_FORMAT, Halignment: "Right" },
        { rangeAddress: "H7", Halignment: "Left" },
      ];
      applyRangeFormats(sheet, dataRows);

      await dateStampSheet(sheet);
      applyGridStyle({ range: sheet.getRange("B6:H6"), borderColor: "Black", weight: "Medium", edges: ["EdgeBottom"] });
      await context.sync();

      await generateVMSummaryReport(sheet);

      sheet.activate();
      await context.sync();
    });
  } catch (error) {
    throw "Error creating VM Summary template: " + error;
  }
};
